// src/index.js
// Theme CSS must be imported BEFORE App.css so app-specific rules can
// override theme rules (CSS order follows import order).
import "./styles/theme/index.css";
import "./styles/theme/theme.css";
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ThemeProvider } from './contexts/ThemeContext';

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeProvider>
        <App />
    </ThemeProvider>
  </React.StrictMode>
);
